import { useCallback } from 'react';
import useNotifications from 'core/notifications/useNotifications';
import { useParams } from 'react-router';
import { useTranslation } from 'react-i18next';

import {
  UpdateBulkRetargetingStatus,
  useUpdateBulkRetargetingCampaignStatusMutation,
} from 'sections/bulk-retargeting-campaigns/queries/useUpdateBulkRetargetingStatus';
import { useCampaignEditorContext } from '../state/hooks/useCampaignEditorContext';

export const useUpdateCampaignStatus = () => {
  const { t } = useTranslation('campaigns');
  const { showNotification } = useNotifications();
  const { dispatch } = useCampaignEditorContext();
  const mutation = useUpdateBulkRetargetingCampaignStatusMutation();
  const { siteId, campaignId } = useParams<{ siteId: string; campaignId: string }>();

  const updateStatus = useCallback(
    async (status: UpdateBulkRetargetingStatus) => {
      try {
        const response = await mutation.mutateAsync({
          siteId,
          campaignId,
          state: status,
        });

        dispatch({ type: 'SET_STATUS', payload: response.data });
      } catch (error) {
        showNotification(t('bulkRetargetingCampaigns.editor.editStatusError'), 'error');
      }
    },
    [campaignId, dispatch, mutation, showNotification, siteId, t],
  );

  return {
    updateStatus,
    ...mutation,
  };
};
